import { connect } from 'react-redux';
import { get } from 'lodash';
import { isUserLoggedIn } from 'apps/user/helpers';

import { Reviews } from '../components/reviews/Reviews';
import {
  fetchReviews,
  deleteReview,
  setHelpfulness,
  updateFields,
  setActivePage,
  resetActivePage,
  setModalVisibility,
  setSortOrder,
} from '../actions/reviews';

export default connect(
  (state, ownProps) => {
    const { sku } = ownProps;
    const userReview = state.reviews.reviews.find(review => (
      review.customerNickname === get(state, 'user.customerDetails.customerNickname')
    ));
    return {
      sku,
      isLoggedIn: isUserLoggedIn(state.user),
      ...state.reviews,
      userReview,
      activePage: state.reviews.activePage,
      sortOrder: state.reviews.sortOrder,
    };
  }, {
    fetchReviews,
    deleteReview,
    setHelpfulness,
    setActivePage,
    resetActivePage,
    updateFields,
    setModalVisibility,
    setSortOrder,
  }
)(Reviews);
